import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyFormat',
})
export class CurrencyFormatPipe implements PipeTransform {
  transform(value: string | number) {
    if (!value) return '0';
    if (typeof value == 'number') {
      if (value >= 0) value = value.toString();
      else return '--';
    } else if (isNaN(parseInt(value))) return '--';

    let [integer, fraction] = value.split('.');
    //console.log(integer);
    let formattedValue = addComma(integer);
    if (fraction != undefined) formattedValue += '.' + fraction.slice(0, 3);
    return formattedValue;
  }
}

function addComma(val: string) {
  let num1 = "";
  val = [...val].reverse().join('');
  let fragments = val
    .match(/(.{1,3})/g)
    ?.map((el) => [...el].reverse().join(''));
  fragments?.reverse();

  if (fragments)
    fragments.forEach((element, idx, array) => {
      if (idx === array.length - 1 || element == "-") { num1 = num1 + element }
      else { num1 = num1 + element + "," }

    });

  return num1;
}
